export default {
    meta: {
        title: 'Cars for Sale - Used Cars, New Cars, SUVs, and Trucks - Autotrader',
        description:
            "Find used cars and new cars for sale at Autotrader. With millions of cars, finding your next new car or used car and the car reviews and information you're looking for is easy at Autotrader.",
        canonicalUrl: 'https://www.autotrader.com',
        ogImage: 'https://content.autotrader.com/content/dam/autotrader/collections/collections-og-image.png',
    },
    heading: {
        title: 'Cars for Sale - Search Near You',
    },
    fallbackSuperHero: {
        useFallback: true,
        contentType: 'client_provided_content',
        image: '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_1300x475.jpg',
        imageMd:
            '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_1024x475.jpg',
        imageSm:
            '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_768x475.jpg',
        imageSs:
            '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_375x470.jpg',
        ctaText: 'Shop Cars for Sale',
        logo: '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/at_logo.png',
        fallbackGamData: {},
        fallbackInfo: {
            title: 'My Wallet',
            subtitle: 'Set a budget and get real payments on every car',
        },
    },
    fallbackEnhancedSuperHero: [{
        useFallback: true,
        richMediaType: 'animated_header',
        animation: false,
        bodyText: {
            contentSelect: 'client_provided_content',
            header: '',
            image: '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_1300x475.jpg',
            imageMd:
                    '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_1024x475.jpg',
            imageSm:
                    '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_768x475.jpg',
            imageSs:
                    '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/hero_fallback_wallet_375x470.jpg',
        },
        ctaText: 'Shop Cars for Sale',
        logo: '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/at_logo.png',
        fallbackGamData: {},
        fallbackInfo: {
            title: 'My Wallet',
            subtitle: 'Set a budget and get real payments on every car',
        },
    }],
    marketValueFallBackContent: [
        {
            acf: {
                headline: 'Find Your Next Car',
                subheader: "Finally It's Easy...",
                body_text: [
                    {
                        subheader: 'Find Your Next Car',
                        paragraph:
                            "Finally It's Easy...Shop Over 3 Million Cars Search for used, certified and new cars near you",
                    },
                    {
                        subheader: 'Buy Your Next Car From Home',
                        paragraph:
                            "Experience a virtual walkaround of the car via video chat with dealer, test drives, and delivery to your door. <a href='https://www.autotrader.com/'> Search available vehicles</a>",
                    },
                    {
                        subheader: 'Feel Confident in the Price You Pay',
                        paragraph:
                            'Kelley Blue Book price guidance on every listing',
                    },
                ],
                external_link: true,
                cta_text: 'Find your Next Car',
                cta_button_type: 'secondary',
                destination_url: 'https://www.autotrader.com/',
                background_color: '#FFFFFF',
                background_image_mobile:
                    'https://www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/AT_Feb_final_website-header_1300x444mobile_1000x664_text.png',
                background_image_desktop:
                    'https://www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/AT_Feb_final_website-header_1300x444desktop_1300x444_text.png',
                background_position_desktop: 'top',
                background_position_mobile: 'top',
                image: false,
                image_scaling: 'cover',
                image_position: 'center',
                video: false,
                text_color: '#FFFFFF',
                background_scaling_mobile: 'cover',
                background_scaling_desktop: 'cover',
            },
        },
    ],
    marketValueFallBackContentWithVideo: [
        {
            acf: {
                headline: 'Find Your Next Car',
                subheader: "Finally It's Easy...",
                body_text: [
                    {
                        subheader: 'Find Your Next Car',
                        paragraph:
                            "Finally It's Easy...Shop Over 3 Million Cars Search for used, certified and new cars near you",
                    },
                    {
                        subheader: 'Buy Your Next Car From Home',
                        paragraph:
                            "Experience a virtual walkaround of the car via video chat with dealer, test drives, and delivery to your door. <a href='https://www.autotrader.com/'> Search available vehicles</a>",
                    },
                    {
                        subheader: 'Feel Confident in the Price You Pay',
                        paragraph:
                            'Kelley Blue Book price guidance on every listing',
                    },
                ],
                external_link: false,
                cta_text: 'Find your Next Car',
                cta_button_type: 'primary',
                destination_url: 'https://www.autotrader.com/',
                background_color: false,
                background_image_mobile: false,
                background_image_desktop: false,
                background_position_desktop: 'top',
                background_position_mobile: 'top',
                image: 'https://www.lexus.com/content/dam/lexus/images/homepage/content-tile/2021/Lexus-862b-2021-Homepage-Tile-750x460_M85.jpg',
                image_scaling: 'cover',
                image_position: 'top',
                video: '',
            },
        },
    ],
    heroRefreshChallenger: {
        image: '//www.autotrader.com/content/dam/autotrader/homepage/hero/AT_25Redesign_AH_HeroImage_DT_1300x560.jpg',
        imageMd: '//www.autotrader.com/content/dam/autotrader/homepage/hero/AT_25Redesign_AH_HeroImage_iPadPro_1024x560.jpg',
        imageSm: '//www.autotrader.com/content/dam/autotrader/homepage/hero/AT_25Redesign_AH_HeroImage_iPadPortrait_768x560.jpg',
        imageSs: '//www.autotrader.com/content/dam/autotrader/homepage/hero/AT_25Redesign_AH_HeroImage_Smartphone_375x330.jpg',
    },
    heroRefreshControl: {
        useFallback: true,
        ctaText: 'Shop Cars for Sale',
        logo: '//www.autotrader.com/content/dam/autotrader/integrated_ads/_non_oem/_ATC_nonSponsored/at_logo.png',
        fallbackGamData: {},
        fallbackInfo: {
            title: 'My Wallet',
            subtitle: 'Set a budget and get real payments on every car',
        },
        image: '//www.autotrader.com/content/dam/autotrader/homepage/hero/25AT_SH_MyWallet_BU_Desktop_1300x475.jpg',
        imageMd: '//www.autotrader.com/content/dam/autotrader/homepage/hero/25AT_SH_Template_TabletLandscape_1024x475.jpg',
        imageSm: '//www.autotrader.com/content/dam/autotrader/homepage/hero/25AT_SH_MyWallet_BU_TabletPortrait_768x475.jpg',
        imageSs: '//www.autotrader.com/content/dam/autotrader/homepage/hero/25AT_SH_MyWallet_BU_Smartphone_375x470.jpg',
    },
};
